<div class="service-area-page">

    <!-- =====================================================
         HERO SECTION
    ====================================================== -->
    <section class="service-area-hero">
        <div class="service-area-container">

            <h1 class="hero-title" [innerHTML]="currentArea.heroTitlePrefix + '<span class=\'highlight\'>' + currentArea.heroHighlight + '</span>'"></h1>

            <p class="hero-description">
                {{ currentArea.heroDescription }}
            </p>

            <div class="hero-cta">
                <a [href]="currentArea.phoneTel" class="hero-phone-btn">
                    ☎ {{ currentArea.phone }}
                </a>

                <a routerLink="/spekwo-products" [queryParams]="{ product: 'full' }" class="hero-quote-btn">
                    Request a Quote
                    <span>→</span>
                </a>
            </div>

            <div class="communities-wrapper">
                <div class="communities-label">
                    COMMUNITIES WE SERVE
                </div>

                <div class="communities-list">
                    <span *ngFor="let community of currentArea.communities" class="community-pill">
                        {{ community }}
                    </span>
                </div>
            </div>

        </div>
    </section>


    <!-- =====================================================
         01 / HOW IT WORKS
    ====================================================== -->
    <section class="steps-section">
        <div class="service-area-container">

            <div class="section-label centered" data-reveal>
                <span></span>
                <span class="label-text">01 / HOW IT WORKS</span>
                <span></span>
            </div>

            <h2 class="section-heading" data-reveal>
                Three steps. <span>One partner.</span>
            </h2>

            <div class="steps-grid">
                <div *ngFor="let step of steps; let i = index" 
                     class="step-card" 
                     [class.dark-step]="step.dark" 
                     data-reveal 
                     [attr.data-reveal-delay]="i * 120">
                    <div class="step-number" [class.orange-stroke]="i > 0">{{ step.number }}</div>
                    <h3 class="step-title">{{ step.title }}</h3>
                    <p class="step-description">{{ step.description }}</p>
                </div>
            </div>

        </div>
    </section>


    <!-- =====================================================
         02 / QUOTES SECTION
    ====================================================== -->
    <section class="quotes-section">
        <div class="service-area-container">

            <div class="section-label centered" data-reveal>
                <span></span>
                <span class="label-text">{{ currentArea.quotesSectionLabel }}</span>
                <span></span>
            </div>

            <h2 class="section-heading" data-reveal>
                Pick your <span>quote.</span>
            </h2>

            <div class="quotes-grid">
                <a *ngFor="let product of products; let i = index"
                   [routerLink]="product.linkUrl"
                   [queryParams]="product.queryParams"
                   class="quote-card"
                   [class.featured-quote]="product.highlight"
                   data-reveal
                   [attr.data-reveal-delay]="i * 100">

                    <span class="quote-tag" [class.orange-tag]="product.highlight">{{ product.tag }}</span>
                    <h3 class="quote-title">{{ product.title }}</h3>
                    <div class="quote-price">{{ product.price }}</div>
                    <p class="quote-description">{{ product.description }}</p>
                    <span class="quote-action" [class.orange-action]="product.highlight">Request →</span>
                </a>
            </div>

        </div>
    </section>


    <!-- =====================================================
         03 / REVIEWS SECTION
    ====================================================== -->
    <section class="reviews-section">
        <div class="service-area-container">

            <div class="section-label centered" data-reveal>
                <span></span>
                <span class="label-text">03 / REVIEWS</span>
                <span></span>
            </div>

            <h2 class="section-heading" data-reveal>
                What agents <span>say</span>
            </h2>

            <div class="reviews-grid">
                <figure *ngFor="let review of testimonials; let i = index"
                        class="review-card"
                        data-reveal
                        [attr.data-reveal-delay]="i * 100">
                    <div class="review-stars" aria-label="5 out of 5 stars">★★★★★</div>
                    <blockquote class="review-quote">{{ review.quote }}</blockquote>
                    <figcaption class="review-author-wrap">
                        <img [src]="review.avatarUrl" [alt]="review.author" class="review-avatar" />
                        <span class="review-author-info">{{ review.author }} · {{ review.affiliation }}</span>
                    </figcaption>
                </figure>
            </div>

            <div class="reviews-cta" data-reveal>
                <a routerLink="/testimonials" class="reviews-btn">
                    Read all reviews
                    <span>→</span>
                </a>
            </div>

        </div>
    </section>


    <!-- =====================================================
         04 / FAQ SECTION
    ====================================================== -->
    <section class="faq-section">
        <div class="service-area-container faq-container">

            <div class="section-label centered" data-reveal>
                <span></span>
                <span class="label-text">04 / FAQ</span>
                <span></span>
            </div>

            <div class="faq-list">
                <details *ngFor="let faq of currentArea.faqs; let i = index"
                         class="faq-item"
                         [open]="faq.isOpen"
                         data-reveal
                         [attr.data-reveal-delay]="i * 80">
                    <summary class="faq-summary" (click)="toggleFaq(i); $event.preventDefault()">
                        <span class="faq-question">{{ faq.question }}</span>
                        <span class="faq-icon">{{ faq.isOpen ? '−' : '+' }}</span>
                    </summary>
                    <p class="faq-answer" *ngIf="faq.isOpen">
                        {{ faq.answer }}
                    </p>
                </details>
            </div>

            <p class="faq-footer-note" data-reveal>
                More questions? 
                <a routerLink="/faq" class="bold-link">Read all FAQs</a> · Also serving 
                <ng-container *ngFor="let other of currentArea.otherAreas; let last = last; let i = index">
                    <a [routerLink]="other.route">{{ other.name }}</a>{{ last ? '.' : (i === currentArea.otherAreas.length - 2 ? ' and ' : ', ') }}
                </ng-container>
            </p>

        </div>
    </section>

</div>
